import GloLayout from 'lowcode/common/GloLayout';
import { useState } from 'react';
import ClientComp from './ClientComp';
import './index.scss';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { loginType } = data;
    const [isLogin, setIsLogin] = useState(false);

    return (
        <GloLayout id={id} className={`temp-member-ecocredits-banner 21 temp-hide`}>
            <ClientComp loginType={loginType} />
        </GloLayout>
    );
}
